module.exports = __webpack_public_path__ + "static/map-light-beb258027a30f0e2171d9dad7117b84e.svg";